.root {
  --radio--size: 20px;
  --radio--size-inset: 8px;
  --radio--border-width: 1px;
  --radio--border-radius: 100%;
  --radio--padding: var(--theme--sizing--1x);
  --radio--color--main: var(--theme--color--mono--black);
  --radio--color--dark: var(--theme--color--dark-grey--dark);
  --radio--color--contrast: var(--theme--color--mono--white);
  --radio--color--ultra-light: var(--theme--color--dark-grey--ultra-light);


  & {
    background-color: var(--theme--color--mono--white);
    border-radius: var(--radio--border-radius, 100%);
    border: var(--radio--border-width, 1px) solid var(--radio--color--main, var(--theme--color--mono--black));
    display: inline-flex;
    width: var(--radio--size, 20px);
    height: var(--radio--size, 20px);
    position: relative;
    vertical-align: top;
    cursor: pointer;
    text-align: center;
    appearance: none;
    margin: 0;
    outline-offset: 2px;
    flex-shrink: 0;

    &.error:not(&.disabled) {
      border-color: var(--theme--color--signal--danger--main);
      background: var(--theme--color--signal--danger--contrast);

      &.active {
        border-color: var(--theme--color--signal--danger--main);
        background: var(--theme--color--signal--danger--main);

        &:before {
          background: var(--theme--color--signal--danger--contrast);
        }
      }


      &:before {
        background: var(--theme--color--signal--danger--main);
      }
    }

    &:not(&.disabled) {
      &:hover {
        border-color: var(--radio--color--dark);
        background: var(--radio--color--ultra-light);
      }

      &:focus-visible,
      &:focus-within {
        outline: 2px solid var(--radio--color--ultra-light);
      }
    }

    &.disabled {
      cursor: not-allowed;
      border-color: var(--theme--color--dark-grey--main);

      &.active {
        background: var(--theme--color--dark-grey--main);

        &:before {
          display: block;
          background: var(--radio--color--contrast);
        }
      }
    }

    &.active {
      background: var(--theme--color--dark-grey--main);

      &:before {
        display: block;
        background: var(--radio--color--contrast);
      }
    }


    &.active:not(&.disabled) {
      background-color: var(--radio--color--main);

      &:before {
        display: block;
      }

      &:focus-visible,
      &:focus-within,
      &:hover {
        background: var(--radio--color--dark);
      }
    }

    &:before {
      display: none;
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      border-radius: var(--radio--border-radius, 100%);
      transform: translate3d(-50%, -50%, 0);
      background: var(--radio--color--contrast, var(--theme--color--mono--white));
      width: var(--radio--size-inset, 8px);
      height: var(--radio--size-inset, 8px);
    }
  }
}